// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhi_sq","PhotoTitleEditForm__cancelBtn":"iy_b bhi_su bhi_st"};